// extracted by mini-css-extract-plugin
module.exports = {"nav_button":"NavigationButtons_nav_button__yd88Y","prev_slide":"NavigationButtons_prev_slide__d5so3","next_slide":"NavigationButtons_next_slide__Fdahx"};